
const getStyles = (theme) => ({
  list: {
    borderBottom : "solid 1px #AFAFAF",
    width: "100%"
  }
});

export default getStyles;